export interface MovieItem {
  id: number;
  title: string;
  category: 'movie' | 'tv' | 'anime' | 'variety';
  subcategory: string;
  year: number;
  rating: number;
  description: string;
  image: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  duration: string;
  region: string;
  director: string;
  actors: string[];
  episodes: string;
  updateInfo: string;
}

export const movies: MovieItem[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    subcategory: '科幻',
    year: 2026,
    rating: 9.2,
    description: '太阳急速老化，持续膨胀，地球面临被吞噬的危机。人类再次团结一致，启动"流浪地球计划"第三阶段。面对未知的宇宙挑战，人类文明能否延续？史诗级科幻巨制，震撼人心的视觉奇观，探讨人类命运共同体的宏大主题。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%2C%20dramatic%20space%20scene%20with%20earth%20and%20stars%2C%20warm%20orange%20and%20gold%20lighting%2C%20cinematic%20composition%2C%20dark%20background%20with%20glowing%20elements%2C%20epic%20scale%2C%20movie%20poster%20aesthetic%2C%20professional%20film%20photography%20quality&width=600&height=800&seq=niuniu-movie-01&orientation=portrait',
    tags: ['硬核科幻', '视觉盛宴', '国产之光'],
    isHot: true,
    isNew: true,
    duration: '148分钟',
    region: '中国大陆',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    episodes: '全1集',
    updateInfo: '2026年春节档热映中',
  },
  {
    id: 2,
    title: '哪吒之魔童闹海',
    category: 'movie',
    subcategory: '动画',
    year: 2025,
    rating: 9.5,
    description: '天劫之后，哪吒与敖丙的灵魂得以保留，但肉身即将消散。太乙真人欲用七色宝莲为二人重塑肉身，却遭遇重重困难。哪吒与敖丙的命运将何去何从？国漫巅峰之作，画风精美绝伦，故事感人至深。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%2C%20mythological%20character%20with%20fire%20elements%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20dynamic%20action%20pose%2C%20traditional%20Chinese%20aesthetic%20with%20modern%20animation%20style%2C%20cinematic%20lighting%2C%20epic%20fantasy%20atmosphere&width=600&height=800&seq=niuniu-movie-02&orientation=portrait',
    tags: ['国漫之光', '神话改编', '视觉震撼'],
    isHot: true,
    isNew: false,
    duration: '144分钟',
    region: '中国大陆',
    director: '饺子',
    actors: ['吕艳婷', '陈浩', '囧森瑟夫'],
    episodes: '全1集',
    updateInfo: '票房突破150亿',
  },
  {
    id: 3,
    title: '封神第二部：战火西岐',
    category: 'movie',
    subcategory: '奇幻',
    year: 2025,
    rating: 8.8,
    description: '殷商大军兵临西岐城下，姜子牙率昆仑弟子与众将迎战。姬发在战火中逐渐觉醒，发现自己的真实身份与使命。一场关乎天下命运的封神大战即将全面爆发。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%2C%20ancient%20warriors%20in%20armor%20with%20mythological%20beasts%2C%20dramatic%20battle%20scene%2C%20gold%20and%20bronze%20color%20tones%2C%20traditional%20Chinese%20elements%2C%20cinematic%20composition%2C%20dark%20atmospheric%20background&width=600&height=800&seq=niuniu-movie-03&orientation=portrait',
    tags: ['史诗巨制', '神话传奇', '豪华阵容'],
    isHot: true,
    isNew: false,
    duration: '150分钟',
    region: '中国大陆',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    episodes: '全1集',
    updateInfo: '口碑持续上升',
  },
  {
    id: 4,
    title: '热辣滚烫',
    category: 'movie',
    subcategory: '喜剧',
    year: 2024,
    rating: 8.3,
    description: '一个善良的女孩在经历了一系列人生打击后，决定通过拳击重新找回自我。在拳击台上，她挥洒汗水，也挥别过去的阴霾。一部让人笑着流泪的励志喜剧，献给每一个努力生活的你。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%2C%20boxing%20theme%2C%20warm%20lighting%2C%20inspirational%20vibe%2C%20bright%20and%20hopeful%20atmosphere%2C%20red%20and%20warm%20tones%2C%20modern%20cinematic%20style%2C%20clean%20composition&width=600&height=800&seq=niuniu-movie-04&orientation=portrait',
    tags: ['励志喜剧', '感动人心', '春节档'],
    isHot: false,
    isNew: false,
    duration: '129分钟',
    region: '中国大陆',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    episodes: '全1集',
    updateInfo: '已完结',
  },
  {
    id: 5,
    title: '满江红',
    category: 'movie',
    subcategory: '历史',
    year: 2023,
    rating: 8.5,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇凶案揭开层层迷雾，小兵张大与亲兵营副统领孙均卷入其中。悬疑与喜剧交织，家国情怀贯穿始终，最后全军复诵《满江红》的场面令人热血沸腾。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20movie%20poster%2C%20Song%20dynasty%20aesthetic%2C%20dark%20red%20and%20black%20tones%2C%20ancient%20Chinese%20courtyard%20atmosphere%2C%20mysterious%20and%20dramatic%2C%20cinematic%20lighting%2C%20traditional%20ink%20wash%20painting%20style&width=600&height=800&seq=niuniu-movie-05&orientation=portrait',
    tags: ['悬疑反转', '家国情怀', '张艺谋'],
    isHot: false,
    isNew: false,
    duration: '159分钟',
    region: '中国大陆',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    episodes: '全1集',
    updateInfo: '已完结',
  },
  {
    id: 6,
    title: '孤注一掷',
    category: 'movie',
    subcategory: '犯罪',
    year: 2023,
    rating: 8.0,
    description: '程序员潘生和模特安娜被海外高薪招聘所诱惑，出国后却沦为诈骗工厂的工具。在绝望中，两人试图逃离魔窟，一场惊心动魄的逃生之旅就此展开。根据真实事件改编，揭露境外网络诈骗的残酷真相。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%2C%20dark%20and%20tense%20atmosphere%2C%20neon%20lighting%20in%20Southeast%20Asian%20setting%2C%20dramatic%20shadows%2C%20suspenseful%20composition%2C%20modern%20cinematic%20style%2C%20dark%20red%20accents&width=600&height=800&seq=niuniu-movie-06&orientation=portrait',
    tags: ['真实改编', '反诈骗', '悬疑惊悚'],
    isHot: false,
    isNew: false,
    duration: '130分钟',
    region: '中国大陆',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅'],
    episodes: '全1集',
    updateInfo: '已完结',
  },
  {
    id: 7,
    title: '庆余年第二季',
    category: 'tv',
    subcategory: '古装',
    year: 2024,
    rating: 9.3,
    description: '范闲假死脱身后重返京都，面临更加复杂的朝堂斗争与江湖恩怨。各方势力暗流涌动，范闲的身世之谜逐渐揭开，一场更大的棋局正在展开。权谋与武侠完美融合，演技派云集的年度爆款。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%2C%20elegant%20ancient%20Chinese%20aesthetic%2C%20scholar%20in%20traditional%20robes%2C%20warm%20golden%20and%20dark%20blue%20accents%2C%20cinematic%20composition%2C%20palace%20atmosphere%2C%20professional%20drama%20photography&width=600&height=800&seq=niuniu-movie-07&orientation=portrait',
    tags: ['古装权谋', '演技派', '年度爆款'],
    isHot: true,
    isNew: true,
    duration: '45分钟/集',
    region: '中国大陆',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    episodes: '更新至36集',
    updateInfo: '每周一至周五更新',
  },
  {
    id: 8,
    title: '繁花',
    category: 'tv',
    subcategory: '年代',
    year: 2024,
    rating: 9.4,
    description: '九十年代的上海，人人都想抓住机遇改变命运。阿宝凭借智慧与勇气在商界崭露头角，成为黄河路上的一代传奇。王家卫导演首部电视剧，极致美学影像，重现上海滩的黄金年代。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%201990s%20Shanghai%20aesthetic%2C%20nostalgic%20warm%20lighting%2C%20vintage%20fashion%20style%2C%20golden%20and%20amber%20tones%2C%20cinematic%20composition%2C%20Wong%20Kar%20Wai%20style%20atmosphere&width=600&height=800&seq=niuniu-movie-08&orientation=portrait',
    tags: ['王家卫', '上海风情', '年代经典'],
    isHot: true,
    isNew: false,
    duration: '50分钟/集',
    region: '中国大陆',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣'],
    episodes: '全30集',
    updateInfo: '已完结',
  },
  {
    id: 9,
    title: '三体',
    category: 'tv',
    subcategory: '科幻',
    year: 2023,
    rating: 8.9,
    description: '纳米科学家汪淼被警官史强带入一个神秘组织，揭开了地外文明"三体"世界的面纱。人类文明与三体文明的首次接触，带来了一场跨越光年的智慧较量。刘慈欣同名科幻巨著改编，国产科幻剧集的里程碑。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20drama%20poster%2C%20cosmic%20and%20mysterious%20atmosphere%2C%20three%20suns%20concept%2C%20dark%20space%20background%20with%20light%20accents%2C%20futuristic%20yet%20grounded%20aesthetic%2C%20cinematic%20quality%2C%20warm%20amber%20highlights&width=600&height=800&seq=niuniu-movie-09&orientation=portrait',
    tags: ['硬核科幻', '刘慈欣', '国产里程碑'],
    isHot: false,
    isNew: false,
    duration: '45分钟/集',
    region: '中国大陆',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾'],
    episodes: '全30集',
    updateInfo: '已完结',
  },
  {
    id: 10,
    title: '狂飙',
    category: 'tv',
    subcategory: '刑侦',
    year: 2023,
    rating: 9.1,
    description: '一线刑警安欣与黑恶势力展开长达二十年的生死较量。从意气风发的青年到满头白发的中年，安欣从未放弃对正义的追求。扫黑除恶题材力作，张译张颂文演技炸裂，年度现象级爆款。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%2C%20police%20and%20gangster%20theme%2C%20dark%20and%20intense%20atmosphere%2C%20dual%20protagonist%20composition%2C%20urban%20Chinese%20setting%2C%20dramatic%20lighting%2C%20professional%20TV%20drama%20photography&width=600&height=800&seq=niuniu-movie-10&orientation=portrait',
    tags: ['扫黑除恶', '演技炸裂', '现象级'],
    isHot: false,
    isNew: false,
    duration: '45分钟/集',
    region: '中国大陆',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    episodes: '全39集',
    updateInfo: '已完结',
  },
  {
    id: 11,
    title: '斗罗大陆',
    category: 'anime',
    subcategory: '热血',
    year: 2023,
    rating: 8.7,
    description: '唐门外门弟子唐三因偷学内门绝学而被追捕，跳崖明志后穿越到斗罗大陆。在这个武魂觉醒的世界中，唐三凭借前世记忆与不懈努力，一步步成长为最强的魂师。国产3D动画标杆之作，热血与感动并存。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20poster%2C%20fantasy%20martial%20arts%20character%20with%20magical%20elements%2C%20dynamic%20action%20pose%2C%20blue%20and%20gold%20energy%20effects%2C%20epic%20fantasy%20world%20background%2C%20professional%20animation%20quality&width=600&height=800&seq=niuniu-movie-11&orientation=portrait',
    tags: ['3D国漫', '热血战斗', '唐家三少'],
    isHot: true,
    isNew: false,
    duration: '20分钟/集',
    region: '中国大陆',
    director: '沈乐平',
    actors: ['配音演员'],
    episodes: '更新至263集',
    updateInfo: '持续更新中',
  },
  {
    id: 12,
    title: '凡人修仙传',
    category: 'anime',
    subcategory: '仙侠',
    year: 2024,
    rating: 9.0,
    description: '普通的山村少年韩立，机缘巧合下进入修仙门派。资质平平的他凭借超乎常人的谨慎与坚韧，在尔虞我诈的修仙界中一步步逆袭。凡人修仙，步步惊心，一部写尽修仙残酷与真实的神作。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%2C%20immortal%20cultivator%20in%20traditional%20robes%2C%20misty%20mountain%20background%2C%20spiritual%20energy%20effects%2C%20elegant%20and%20mysterious%20atmosphere%2C%20traditional%20Chinese%20ink%20painting%20influence%2C%20warm%20golden%20light&width=600&height=800&seq=niuniu-movie-12&orientation=portrait',
    tags: ['修仙经典', '凡人逆袭', '制作精良'],
    isHot: false,
    isNew: true,
    duration: '22分钟/集',
    region: '中国大陆',
    director: '王裕仁',
    actors: ['配音演员'],
    episodes: '更新至108集',
    updateInfo: '每周六更新',
  },
  {
    id: 13,
    title: '奔跑吧·生态篇',
    category: 'variety',
    subcategory: '真人秀',
    year: 2024,
    rating: 8.2,
    description: '奔跑吧兄弟团再次集结，开启全新的生态探索之旅。从热带雨林到高原雪山，成员们在挑战中传递环保理念，展现团队精神。笑点密集，温情满满，国民综艺的又一次进化。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20celebrities%20in%20casual%20sportswear%2C%20outdoor%20natural%20setting%2C%20bright%20and%20energetic%20atmosphere%2C%20warm%20sunlight%2C%20fun%20and%20dynamic%20composition%2C%20professional%20entertainment%20photography&width=600&height=800&seq=niuniu-movie-13&orientation=portrait',
    tags: ['国民综艺', '户外竞技', '合家欢'],
    isHot: true,
    isNew: false,
    duration: '90分钟/期',
    region: '中国大陆',
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深'],
    episodes: '更新至12期',
    updateInfo: '每周五更新',
  },
  {
    id: 14,
    title: '向往的生活·第八季',
    category: 'variety',
    subcategory: '慢综艺',
    year: 2024,
    rating: 8.5,
    description: '回归田园，慢享生活。黄磊与何炅带领新老朋友在蘑菇屋中体验最纯粹的乡村生活。自己种菜、做饭、聊天，在快节奏的都市生活中，寻找那一份宁静与温暖。治愈系慢综艺的巅峰之作。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20slow%20lifestyle%20variety%20show%20poster%2C%20rural%20countryside%20setting%20with%20cozy%20wooden%20house%2C%20warm%20sunset%20lighting%2C%20natural%20and%20peaceful%20atmosphere%2C%20green%20fields%20and%20mountains%2C%20nostalgic%20and%20healing%20vibe&width=600&height=800&seq=niuniu-movie-14&orientation=portrait',
    tags: ['治愈慢综', '田园生活', '美食治愈'],
    isHot: false,
    isNew: true,
    duration: '100分钟/期',
    region: '中国大陆',
    director: '王征宇',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅'],
    episodes: '更新至10期',
    updateInfo: '每周日更新',
  },
];

export const getMoviesByCategory = (category: MovieItem['category']) => {
  return movies.filter((m) => m.category === category);
};

export const getHotMovies = () => {
  return movies.filter((m) => m.isHot);
};

export const getNewMovies = () => {
  return movies.filter((m) => m.isNew);
};

export const getMovieById = (id: number) => {
  return movies.find((m) => m.id === id);
};